// extracted by mini-css-extract-plugin
export default {"list":"nav_list__eEeXU","menu":"nav_menu__CCoAt nav_list__eEeXU"};